"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";
import MobileMenuDrawer from "./MobileMenuDrawer";

const Header = () => {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(0);

  const isHelpCenter = pathname === "/help-center";

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleScroll = () => {
      setScrolled(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  return (
    <header
      className={`h-16 lg:h-23 transition-all duration-300 ${
        scrolled > 200 || isHelpCenter ? "bg-[#383838] shadow-lg" : ""
      }`}
    >
      <DesktopNav />
      <MobileNav open={open} setOpen={setOpen} />
      <MobileMenuDrawer open={open} setOpen={setOpen} />
    </header>
  );
};

export default Header;
